import { Action } from 'redux';

import {
  ClearSpaceContentCounts, ContentCountsRequest, ContentCountsRequestSucceeded,
  ContentCountsUpToDate, DecrementContentCount, IncrementContentCount, UpdateSpaceInfoCount
} from '../../bootstrap/redux/actions/AppActionTypes';
import { isActionFactory } from '../../bootstrap/redux/actions/isActionFactory';
import { SpaceInfoTypeContentCounts } from '../state/ContentCountsState';
import { SpaceInfo, SpaceType, SubspaceName } from '../state/SpaceInfo';

// ContentCountsRequestAction

export interface ContentCountsRequestAction extends Action {}

export function contentCountsRequest(): ContentCountsRequestAction {
  return {
    type: ContentCountsRequest
  };
}

export const isContentCountsRequestAction = isActionFactory<ContentCountsRequestAction>(ContentCountsRequest);

// ContentCountsRequestSucceededAction

export interface ContentCountsRequestSucceededAction extends Action {
  spaceType: SpaceType;
  counts: SpaceInfoTypeContentCounts;
}

export function contentCountsRequestSucceeded(spaceType: SpaceType, counts: SpaceInfoTypeContentCounts): ContentCountsRequestSucceededAction {
  return {
    type: ContentCountsRequestSucceeded,
    spaceType,
    counts
  };
}

export const isContentCountsRequestSucceededAction = isActionFactory<ContentCountsRequestSucceededAction>(ContentCountsRequestSucceeded);

// ClearSpaceContentCountsAction

export interface ClearSpaceContentCountsAction extends Action {
  spaceType: SpaceType;
}

export function clearSpaceContentCountsAction(spaceType: SpaceType): ClearSpaceContentCountsAction {
  return {
    type: ClearSpaceContentCounts,
    spaceType,
  };
}

export const isClearSpaceContentCountsAction = isActionFactory<ClearSpaceContentCountsAction>(ClearSpaceContentCounts);

// UpdateSpaceInfoCountAction

export interface UpdateSpaceInfoCountAction extends Action {
  spaceInfo: SpaceInfo;
  count: number;
}

export function updateSpaceInfoCountAction(spaceInfo: SpaceInfo, count: number): UpdateSpaceInfoCountAction {
  return {
    type: UpdateSpaceInfoCount,
    spaceInfo,
    count
  };
}

export const isUpdateSpaceInfoCountAction = isActionFactory<UpdateSpaceInfoCountAction>(UpdateSpaceInfoCount);

// ContentCountsUpToDate

export interface ContentCountsUpToDateAction extends Action {}

export function contentCountsUpToDate(): ContentCountsUpToDateAction {
  return {
    type: ContentCountsUpToDate
  };
}

export const isContentCountsUpToDateAction = isActionFactory<ContentCountsUpToDateAction>(ContentCountsUpToDate);

export interface UpdateContentCountAction extends Action {
  contentId: string;
  subspaceName: SubspaceName;
  spaceType: SpaceType;
}

export function decrementContentCount(contentId: string, spaceType: SpaceType, subspaceName: SubspaceName): UpdateContentCountAction {
  return {
    type: DecrementContentCount,
    contentId,
    subspaceName,
    spaceType
  };
}

export const isDecrementContentCountAction = isActionFactory<UpdateContentCountAction>(DecrementContentCount);

export function incrementContentCount(contentId: string, spaceType: SpaceType, subspaceName: SubspaceName): UpdateContentCountAction {
  return {
    type: IncrementContentCount,
    contentId,
    subspaceName,
    spaceType
  };
}

export const isIncrementContentCountAction = isActionFactory<UpdateContentCountAction>(IncrementContentCount);
